import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { BENEFIT_PERIODS } from '@src/graphql/queries/benefitPeriod';
import { MuiMultiSelect, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const BenefitPeriodSegmentsPicker = ({ className, label, selected, errors, onChange, disabled, type, year, clientId, }) => {
    const { data } = useQuery(BENEFIT_PERIODS, {
        variables: {
            spec: {
                type,
                year,
                clientId,
            },
        },
    });
    const { t } = useLocale();
    const benefitPeriods = useMemo(() => data?.benefitPeriods || [], [data]);
    const handleChange = (e) => {
        onChange(e.selection.map(s => s.value));
    };
    return (_jsx(MuiMultiSelect, { className: className, label: label, options: benefitPeriods.map(bp => ({
            label: bp.segment ?? t('Not Set'),
            value: bp.segment ?? '',
        })) || [], value: selected, onChange: handleChange, errors: errors, disabled: disabled }));
};
